import React from 'react';

import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
import Nav from 'react-bootstrap/Nav';
import Overlay from 'react-bootstrap/Overlay';
import { Link } from 'react-router-dom';

import MLTooltip from '@src/components/ui/MLTooltip';

import Add from './FavoritesMenuAdd';
import List from './FavoritesMenuList';

const FavoritesMenu = ({ displayName }) => {
    const [showAdded, setShowAdded] = React.useState(false);
    const navRef = React.useRef(null);

    const handleAdd = React.useCallback(() => {
        setShowAdded(true);
        setTimeout(() => setShowAdded(false), 4000);
    }, [setShowAdded]);

    return (
        <>
            <Dropdown
                ref={navRef}
                as={Nav.Item}
                className="icon-after favorite-pages nav-item"
                aria-live="polite"
                ara-atomic="true"
                tabIndex={-1}
            >
                <Dropdown.Toggle
                    as={Nav.Link}
                    role="link"
                    tabIndex={1000}
                >
                    <span className="alerts-title">{displayName}</span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <List />
                    <div className="manage-favorites">
                        <Add onAdd={handleAdd} />
                        <Dropdown.Item
                            as={Link}
                            to="/favorites"
                            className="manage-favorite-pages"
                        >
                            Manage Favorites
                        </Dropdown.Item>
                    </div>
                </Dropdown.Menu>
            </Dropdown>
            <Overlay target={navRef.current} show={showAdded} placement="bottom">
                {(props) => (
                    <MLTooltip {...props}>Page has been added!</MLTooltip>
                )}
            </Overlay>
        </>
    );
};

FavoritesMenu.propTypes = {
    displayName: PropTypes.string.isRequired,
};

export default React.memo(FavoritesMenu);
